import { ApplicationConfig, ErrorHandler, inject, mergeApplicationConfig } from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'

import { CLIENT_CONFIG } from 'app/core/client-config/client-config.token'
import { IS_LOCALHOST } from 'app/core/is-localhost.token'
import { CloudWatchErrorHandler } from 'app/core/logger/cloudwatch/cloud-watch-error-handler.service'
import { CloudWatchLogTransportConfig } from 'app/core/logger/cloudwatch/cloud-watch-log-transport-config.type'
import { withCloudwatchTransport } from 'app/core/logger/cloudwatch/with-cloudwatch-transport.function'
import { withBrowserConsoleTransport } from 'app/core/logger/console/with-browser-console-transport.function'
import { LogLevel } from 'app/core/logger/log-level.enum'
import { provideLogger } from 'app/core/logger/provide-logger'

import { appConfig } from './app.config'
import { providePlausibleAnalytics } from './core/analytics/provide-plausible-analytics.function'
import { provideRouteScrollHandler } from './core/route-scroller/provide-route-scroll-handler.function'

function cloudWatchLogConfigFactory(): CloudWatchLogTransportConfig {
  const { isProd } = inject(CLIENT_CONFIG)
  return {
    logLevel: inject(IS_LOCALHOST) ? LogLevel.OFF : isProd ? LogLevel.ERROR : LogLevel.DEBUG,
    flushInterval: 3000,
  }
}

const browserConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideLogger(
      withBrowserConsoleTransport(() => {
        const { isProd } = inject(CLIENT_CONFIG)
        return { logLevel: isProd ? LogLevel.OFF : LogLevel.DEBUG }
      }),
      withCloudwatchTransport(cloudWatchLogConfigFactory),
    ),

    provideRouteScrollHandler(),
    { provide: ErrorHandler, useClass: CloudWatchErrorHandler }, // could be implemented as `feature` for `provideCloudwatchLogTransport(config, withErrorHandler())
    providePlausibleAnalytics(),
  ],
}

export const config: ApplicationConfig = mergeApplicationConfig(appConfig, browserConfig)
